import React from 'react';

export const MapLink = ({ location, className = '', testId }) => {
  if (!location) return null;
  return (
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId || 'map-link'}
      className={`underline decoration-dotted underline-offset-2 hover:text-[#5d6b3c] transition-colors ${className}`}
      title="Open in Google Maps for directions"
    >
      {location}
    </a>
  );
};
